const aqjcb=[
    {
        path: 'safeCheckItem',
        name: 'safeCheckItem',
        component: () =>
                  import('@/components/aqjcb/safeCheckItem/index.vue'),
        meta: { title: '安全检查项', requireAuth: true, keepAlive: true, permission: true }
      },
      {
        path: 'safeCheckPlan',
        name: 'safeCheckPlan',
        component: () =>
                  import('@/components/aqjcb/safeCheckPlan/index.vue'),
        meta: { title: '安全检查计划', requireAuth: true, keepAlive: true, permission: true }
      },
      {
        path: 'safeCheckTask',
        name: 'safeCheckTask',
        component: () =>
                  import('@/components/aqjcb/safeCheckTask/index.vue'),
        meta: { title: '安全检查任务', requireAuth: true, keepAlive: true, permission: true }
      },
      {
        path: 'safeCheckRecord',
        name: 'safeCheckRecord',
        component: () =>
                  import('@/components/aqjcb/safeCheckRecord/index.vue'),
        meta: { title: '安全检查项台账', requireAuth: true, keepAlive: true, permission: true }
      },
]
export default aqjcb


  



// WEBPACK FOOTER //
// ./src/router/aqjcb.js